










































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import VueRouter from "vue-router";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import Button from "@/shared/components/ui/Button.vue";
import { CardEmployerPrinSettingsRequest } from "@/admin/types";
import { useCardEmployerPrinStore } from "@/admin/store/cardEmployerPrin";
import { useNotifierStore } from "@/shared/store/notifier";

@Component({
  components: {
    Input,
    Button
  }
})

export default class EmployerPrinCardSettings extends Vue {
  $router: VueRouter;
  $validator: Validator;

  @Prop() employerId: number;

  cardEmployerPrinStore = useCardEmployerPrinStore();
  notifierStore = useNotifierStore();

  externalEmployerId = "";
  employerPrin = "";
  isLoaded = false;
  isSubmitting = false;

  mounted (): void {
    this.onEmployerIdChanged();
  }

  @Watch("employerId", { deep: true })
  onEmployerIdChanged () {
      if (this.isSubmitting) {
          return;
      }
      this.isLoaded = false;

      this.cardEmployerPrinStore.getEmployerPrinSettings(this.employerId)
      .then(() => {
        this.employerPrin = this.cardEmployerPrinStore.prin;
        this.externalEmployerId = this.cardEmployerPrinStore.externalEmployerId;
        this.isLoaded = true;
      });
  }

  submit () {
        this.$validator.validateAll().then(isValid => {
            if (!isValid) {
                return;
            }
            this.isSubmitting = true;
            const request: CardEmployerPrinSettingsRequest = {
                employerId: this.employerId,
                prin: this.employerPrin
            };

            this.cardEmployerPrinStore.saveEmployerPrinSettings(request)
                .then(() => {
                  this.notifierStore.setSuccess("Employer Prin has been saved");
                  this.isSubmitting = false;
                });
        });
    }

  get submitDisabled () {
        return this.$validator.errors.any() || this.isSubmitting;
    }
}
